export default {
      id: "info-bell-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#info-bell",
      toString: function () {
        return this.url;
      }
    }